import { Box, Grid } from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from 'features/common/ui/utils/Loader'
import { InfiniteData } from 'react-query'
import { PaginatedResponse } from 'features/common'
import useFixMissingScroll from 'features/common/hooks/useFixMissingScroll'
import { Map } from '../../types'
import MapsList from './MapsList'

interface MapsGalleryListProps {
  next: () => void
  dataLength: number
  hasMore: boolean
  mapsPages: InfiniteData<PaginatedResponse<Map>> | undefined
}

function MapsGalleryList({ dataLength, hasMore, next, mapsPages }: MapsGalleryListProps) {
  useFixMissingScroll({
    hasMoreItems: hasMore,
    fetchMoreItems: next
  })

  const maps = mapsPages?.pages.flatMap((page) => page.data) || []
  return (
    <Box sx={{ mt: 3, mb: 3 }}>
      <InfiniteScroll
        next={next}
        dataLength={dataLength}
        hasMore={hasMore}
        loader={
          <Box mt={5}>
            <Loader />
          </Box>
        }
        scrollableTarget={document.querySelector('main')}
      >
        <Grid container spacing={3}>
          <MapsList maps={maps} />
        </Grid>
      </InfiniteScroll>
    </Box>
  )
}

export default MapsGalleryList
